<template>
	<div class="yklist">
        
        <main>
            
            <span>车辆使用公司：  </span>
            <el-select v-model="gongsi" placeholder="车辆使用公司" style="width: 180px;"  @change="getYk()" >
                <el-option
                    v-for="(item,i) in options2"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span>类型：  </span>
            <el-select v-model="type" placeholder="类型" style="width: 80px;" clearable>
                <el-option label="消费" value="10"></el-option>
                <el-option label="充值" value="20"></el-option>
            </el-select>

            <span>起止日期： </span>
            <el-date-picker
                style="width:320px"
                v-model="search_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button type="success" @click="add()" size="mini" style="margin-left:20px" icon="el-icon-circle-plus-outline">添加油卡</el-button>

        </main>

        <br/>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="yk_list"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    prop="create_time"
                    width="160"
                    label="创建时间">
                </el-table-column>
                
                <el-table-column
                    prop="org"
                    width="260"
                    label="公司">
                </el-table-column>

                <el-table-column
                    prop="type"
                    label="类型">
                </el-table-column>

                <el-table-column
                    prop="num"
                    width="150"
                    label="卡号">
                </el-table-column>

                <el-table-column
                    prop="chepai"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="money"
                    label="余额">
                </el-table-column>

                <el-table-column
                    prop="zhu_num"
                    width="150"
                    label="绑定主卡">
                </el-table-column>

                <el-table-column
                    prop="mess"
                    label="备注">
                </el-table-column>

                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>

                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" style="color:#409EFF;font-weight:600" @click="edit(scope.row)">修改</el-button>
                            <el-button type="text" style="color:#67C23A;font-weight:600" @click="chongZhi(scope.row)">充值</el-button>
                            <el-button type="text" style="color:#E6A23C;font-weight:600;margin-left:10px" @click="mingXi(scope.row)">明细</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>

        <el-dialog
            title="油卡充值"
            :visible.sync="dialogVisible2"
            width='480px'>
            <span style="margin-bottom:20px;font-size:14px;font-weight:600;color:red">提示：副卡余额不能超6000！</span> <br/><br/>
            <el-card>
                <span style="margin-right:30px">卡号 </span>
                <el-input v-model="yk.num" placeholder="请输入内容" style="width:300px" :disabled='true'></el-input>
                <br/>
                <br/>
                <span style="margin-right:30px">车牌 </span>
                <el-input v-model="yk.chepai" placeholder="请输入内容" style="width:300px" :disabled='true'></el-input>
                <br/>
                <br/>
                <span style="margin-right:30px">金额 </span>
                <el-input v-model="yk.money" type="number"  placeholder="请输入金额" style="width:300px"></el-input>
                <br/>
                <br/>
                <span style="margin-right:30px">备注 </span>
                <el-input v-model="yk.beizhu" placeholder="请输入" style="width:300px"></el-input>
                <br/>
                <br/>
                <span style="margin-right:32px">时间</span>
                <el-date-picker
                    style="width:300px"
                    v-model="yk.time"
                    type="datetime"
                    placeholder="选择日期时间">
                </el-date-picker>
                <br/>
                <br/>
                <el-button type="primary" @click="chongSure()" style="margin-left:300px">确定</el-button>
            </el-card>
        </el-dialog>

        <el-dialog
            width="80%"
            title="明细"    
            style="margin-top:-10vh"
            :visible.sync="dialogVisible3">
            <el-card style="border: solid #ccc 1px" > 
                <el-table
                    :data="mingxi_list"
                    stripe
                    border
                    height="50vh"
				    id='outTable'
                    style="width:100%">
                    <el-table-column
                        width="146"
                        prop="order_id"
                        label="订单号">
                    </el-table-column>

                    <el-table-column
                        width="150"
                        prop="num"
                        label="卡号">
                    </el-table-column>

                    <el-table-column
                        prop="chepai"
                        width="90"
                        label="车牌">
                    </el-table-column>

                    <el-table-column
                        prop="time"
                        width="120"
                        label="业务时间">
                    </el-table-column>

                    <el-table-column
                        prop="q_money"
                        width="80"
                        label="操作前">
                    </el-table-column>

                    <el-table-column
                        prop="money"
                        width="80"
                        label="金额">
                    </el-table-column>

                    <el-table-column
                        width="80"
                        prop="h_money"
                        label="操作后">
                    </el-table-column>

                    <el-table-column
                        prop="fangshi"
                        width="80"
                        label="方式">
                    </el-table-column>

                    <el-table-column
                        prop="beizhu"
                        width="150"
                        label="备注">
                    </el-table-column>

                    <el-table-column
                        prop="operate"
                        width="100"
                        label="操作人">
                    </el-table-column>

                    <el-table-column label="类型"  width="120">
                        <template slot-scope="scope">
                            <p>
                                <span v-if="scope.row.type==10" style="color: #67C23A;">支出</span>
                                <span v-if="scope.row.type==20" style="color: #F56C6C;">充值</span>
                                <span style="color: #409EFF;margin-left:20px" @click="daoChu(scope.row)">打印</span>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
                <br/>
                <span style="color: #67C23A;font-weight:600;font-size:16px">支出:{{ all_zc }}</span>
                <span style="color: #F56C6C;font-weight:600;font-size:16px;margin-left:60px">充值:{{ all_cz }}</span>
            </el-card>  
        </el-dialog>

        <el-dialog
            title="油卡维护"
            :visible.sync="dialogVisible"
            width="400px">
            <span style="margin-bottom:20px;font-size:14px;font-weight:600;color:red">提示：副卡余额不能超6000！</span> <br/><br/>
            <el-row>
                <el-col :span="6"><span>公司</span></el-col>
                <el-col :span="18">
                    <el-input size="mini" v-model="yk.org" placeholder="公司" :disabled="true"></el-input>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><span>类型</span></el-col>
                <el-col :span="18">
                    <el-select v-model="yk.type" placeholder="类型" style="width: 100%;" @change="getZfk()" :disabled='yk.zfk_show'>  
                        <el-option label="副卡" value="副卡"></el-option>
                        <el-option label="主副卡" value="主副卡"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><span>卡号</span></el-col>
                <el-col :span="18">
                    <!-- <el-input size="mini" v-model="yk.num" placeholder="卡号" :disabled='yk.disabled_ye'></el-input> -->
                    <el-input size="mini" v-model="yk.num" placeholder="卡号" ></el-input>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><span>余额</span></el-col>
                <el-col :span="18">
                    <el-input size="mini" type="number" v-model="yk.money" :disabled='yk.zfk_show' placeholder="余额"></el-input>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><span>绑定车牌</span></el-col>
                <el-col :span="18">
                    <el-select v-model="yk.chepai" placeholder="车牌" style="width: 100%;">
                        <el-option
                            v-for="(item,i) in tableData"
                            :key="i"
                            :label="item.chepai"
                            :value="item.chepai">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row v-show="yk.show">
                <el-col :span="6"><span>绑定主卡</span></el-col>
                <el-col :span="18">
                    <el-select v-model="yk.zhu_num" placeholder="主卡" style="width: 100%;">
                        <el-option
                            v-for="(item,i) in tableData2"
                            :key="i"
                            :label="item.num"
                            :value="item.num">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="6"><span>备注</span></el-col>
                <el-col :span="18">
                    <el-input size="mini" v-model="yk.mess" placeholder="备注"></el-input>
                </el-col>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
            </span>
        </el-dialog>

        <div id="daochu" style="width: 800px;" v-show="false">
            <div style="padding:20px 40px">
                <h4 style="text-align:center">{{ daochu.org }}</h4>
                <main>
                    <div class="d1">
                        <p>充值日期：{{ daochu.time }}</p>
                        <p>单号：{{ daochu.order_id }}</p>
                    </div>
                    <div class="d2">
                        <p>类型：{{ daochu.type }}</p>
                        <p>方式：{{ daochu.fangshi }}</p>
                        <p>卡号：{{ daochu.num }}</p>
                    </div>
                </main>

                <table border="1" style="width:800px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:150px;height:50px;text-indent:10px">车牌</td>
                        <td style="width:150px;height:50px;text-indent:10px">充值前</td>
                        <td style="width:150px;height:50px;text-indent:10px">金额</td>
                        <td style="width:150px;height:50px;text-indent:10px">充值后(余额)</td>
                    </tr>
                    <tr>
                        <td style="width:150px;height:50px;text-indent:10px">{{ daochu.chepai }}</td>
                        <td style="width:150px;height:50px;text-indent:10px">{{ daochu.q_money }}</td>
                        <td style="width:150px;height:50px;text-indent:10px">{{ daochu.money }}</td>
                        <td style="width:150px;height:50px;text-indent:10px">{{ daochu.h_money }}</td>
                    </tr>
                </table>
                <br/>
                <p style="width:800px;text-align:right">操作人：{{ daochu.operate }}</p>
            </div>
        </div>

    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,carList,ykList,ykList2,ykAdd,ykEdit,url2,ykMingxi  } from '../router/api';
	export default{
		data(){
			return{
                gongsi:'',
                tableData:[],
                tableData2:[],
                options2: [],
                dialogVisible:false,
                dialogVisible2:false,
                dialogVisible3:false,
                yk:{
                    id:'',
                    num:'',
                    chepai:'',
                    money:'',
                    org:'',
                    disabled_ye:false,
                    time:'',
                    mess:'',
                    type:'副卡',
                    zhu_num:'',
                    show:true,
                    zfk_show:false, 
                    beizhu:'',
                },
                yk_list:[],
                mingxi_list:[],
                search_time:[],
                all_zc:0,
                all_cz:0,
                type:'',

                daochu: {
                    order_id:'',
                    num:'',
                    chepai:'',
                    time:'',
                    q_money:'',
                    money:'',
                    h_money:'',
                    operate:'',
                    type:'',
                    org:'',
                    fangshi:'',
                },
                chaoguo3qian:0,
                chaoguo3qian_type:'',
            }
        },
        async mounted() {
            await this.getUser()
            await this.getYk()
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.search_time.push(time1)
            this.search_time.push(time2)
        },
		methods: {
            daoChu(row) {
                this.$nextTick(() => {
                    this.daochu.order_id = row.order_id
                    this.daochu.num = row.num
                    this.daochu.chepai = row.chepai
                    this.daochu.time = row.time
                    this.daochu.q_money = row.q_money
                    this.daochu.money = row.money
                    this.daochu.h_money = row.h_money
                    this.daochu.operate = row.operate
                    this.daochu.type = row.type == 20 ? '充值' : '支出'
                    this.daochu.fangshi = row.fangshi
                })
                setTimeout(()=>{
                        let print = document.querySelector('#daochu')
                        document.body.innerHTML = print.innerHTML
                        window.print()
                        window.location.reload()
                },1000)
            },
            //充值
            chongZhi(row) {
                this.yk.num = row.num,
                this.yk.chepai = row.chepai,
                this.yk.money = '',
                this.yk.time = '',
                this.yk.zhu_num = row.zhu_num
                this.chaoguo3qian = row.money
                this.chaoguo3qian_type = row.type
                this.yk.beizhu = ''    
                this.dialogVisible2 = true
            },
            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },
            chongSure() {
                if(this.yk.money==''||this.yk.time==''){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.chaoguo3qian_type=='副卡'&&Number(this.yk.money)+Number(this.chaoguo3qian)>6000){
                    this.$message.error('油卡余额不能大于6000');
                    return;
                } 
                
                this.yk.time = this.formatDate(this.yk.time)
                this.$confirm('油卡余额一定要和现实油卡余额相符，是否确定?', '提示', {
                    confirmButtonText: '确定相符',
                    cancelButtonText: '取消操作',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caozuoYouka', {
                        params:{
                            id:'',
                            id_status:1,
                            shenpiren:localStorage.getItem('ws_name'),

                            num:this.yk.num,
                            chepai:this.yk.chepai,
                            money:this.yk.money,
                            time:this.yk.time,
                            fangshi:'油卡加油',
                            type:20,
                            zhu_num:this.yk.zhu_num, 
                            beizhu:this.yk.beizhu
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.dialogVisible2 = false
                            this.getYk()
                        } 
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },

            mingXi(row) {
                this.daochu.org = row.org
                var time1 = ''
                var time2 = ''
                if(this.search_time) {
                    time1 = this.search_time[0] + ' 00:00:00'
                    time2 = this.search_time[1] + ' 23:59:59'
                }
                console.log(this.type)
                ykMingxi({
                    num:row.num,
                    crate_time1:time1,
                    crate_time2:time2,
                    type:this.type,
                }).then(res=> {
                    if(res.code==1) {
                        this.mingxi_list = res.data
                        this.dialogVisible3 = true
                        this.all_zc = 0
                        this.all_cz = 0
                        this.mingxi_list.map(item=> {
                            if(item.type == 10) {
                                this.all_zc += Number(item.money)
                            }
                            if(item.type == 20) {
                                this.all_cz += Number(item.money)
                            }
                        })
                        this.all_zc = this.all_zc.toFixed(2)
                        this.all_cz = this.all_cz.toFixed(2)
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list2  = res.data[0].car.split(',')
                    list2.map(item=> {
                        this.options2.push(item)
                    })
                    this.gongsi = this.options2[0]
                    if(this.gongsi == '全部') {
                        this.options2 = option.org
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            async getCar() {
                await carList({
                    id:'',
                    chepai:'',
                    xz_status:'',
                    gongsi:this.gongsi == '全部'? '' : this.gongsi
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            async getYk() {
                await ykList({
                    id:'',
                    org:this.gongsi == '全部'? '' : this.gongsi,
                    chepai:'',
                    zfk:''
                }).then(res=> {
                    if(res.code==1) {
                        this.yk_list = res.data
                    }
                    this.getYk2()
                }).catch(err=> {
                    console.log(err);
                });
            },

            async getYk2() {
                var org = ''
                if(this.gongsi == '全部') {
                    org = ''
                } else if(this.gongsi == '华统股份-养殖事业部' || this.gongsi == '华统股份-鲜品事业部' || this.gongsi == '华统股份-肉品事业部' || this.gongsi == '华统股份-职能部' ) {
                    org = '华统股份'
                } else {
                    org = this.gongsi
                }
                await ykList2({
                    id:'',
                    org:org,
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData2 = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            getZfk() {
                if(this.yk.type=='副卡') {
                    this.yk.show = true
                } else {
                    this.yk.show = false
                }
            },

            add() {
                this.dialogVisible = true
                this.yk =  {
                    id:'',
                    chepai:'',
                    num:'',
                    money:'',
                    org:this.gongsi,
                    mess:'',
                    disabled_ye:false,
                    time:'',
                    type:'副卡',
                    zfk_show:false,
                    zhu_num:'',
                    show:true,
                    beizhu:'',
                }
                this.getCar()
            },

            edit(row) {
                this.dialogVisible = true
                this.yk = {
                    id:row.id,
                    chepai:row.chepai,
                    num:row.num,
                    money:row.money,
                    org:this.gongsi,
                    mess:row.mess,
                    disabled_ye:true,
                    time:'',
                    type:row.type,
                    zfk_show:true,
                    zhu_num:row.zhu_num,
                    beizhu:'',
                }
                this.yk.type=='副卡'? this.yk.show = true: this.yk.show=  false
                this.getCar()
            },

            submit() {
                if(this.yk.type=='副卡'&&this.yk.zhu_num=='') {
                    this.$message.error('请填写完整信息');
                    return;
                }
                if(this.yk.type=='副卡'&&Number(this.yk.money)>6000) {
                    this.$message.error('副卡最多不能超过6000');
                    return;
                }
                if(this.yk.type==''||this.yk.chepai==''||this.yk.org==''||this.yk.money==''||this.yk.num==''){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.yk.id) { 
                    ykEdit({
                        id:this.yk.id,
                        chepai:this.yk.chepai,
                        num:this.yk.num,
                        money:this.yk.money,
                        org:this.yk.org,
                        mess:this.yk.mess,
                        operate:localStorage.getItem('ws_name'),
                        type:this.yk.type,
                        zhu_num:this.yk.zhu_num,
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getYk()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                } else {
                    ykAdd({
                        chepai:this.yk.chepai,
                        num:this.yk.num,
                        money:this.yk.money,
                        org:this.yk.org,
                        mess:this.yk.mess,
                        operate:localStorage.getItem('ws_name'),
                        type:this.yk.type,
                        zhu_num:this.yk.zhu_num,
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getYk()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

        }

    }
</script>

<style scoped="scoped" lang='less'>
    .yklist  {
        #daochu {
            main {
                margin:20px 0;
                display: flex;
                justify-content: space-between;
                p {
                    height: 30px;
                    line-height: 30px;
                }
            }
        }
        .el-row {
            box-sizing: border-box;
            height: 28px;
            line-height: 28px;
            margin-bottom:10px;
        }
        /deep/ .el-dialog__body {
            padding: 10px 20px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
        span {
            font-size: 12px;
        }
        .el-input {
            margin-right: 20px;
        }

        .el-select {
            width:140px;
            margin-right: 20px;
        }
        .cladmin main {
            margin-bottom: 20px;
        }
    }
</style>
